<div style="height: 100%" matRipple>
<app-action-item  borderColor="var(--shade-2-color)" titleColor="#000000"
  backgroundColor="var(--shade-2-color)" color="#000000"
  titleDictionaryKey="dd.appc_cfg_action_item.{{actionItem.id}}.name" [iconCSS]="actionItem?.iconCSS"
  class="barrier-control" (click)="handleClick()">
    <sc-flex centered fitHeight>
      <sc-icon iconClass="fa-gear first-icon"></sc-icon>
      <sc-icon iconClass="{{actionItem?.iconCSS}} second-icon"></sc-icon>
    </sc-flex>
  </app-action-item>
</div>
